import { WidgetContactChooserValueV0Dto } from './models/widget-contact-chooser-value-v0.dto';
import {
  WContactChooserResponseV0Dto
} from '@pt/widgets';
import { WidgetHolderChooserPreviewDataV0 } from './models/widget-contact-chooser-preview-v0.dto';
import { WidgetContactChooserDataV0 } from './models/widget-contact-chooser-data-v0';

export class WidgetContactChooserV0Utils {

  static queryResponseToContactChooserResponse(queryResponse: unknown[], fields: Record<string, string>, placeholders: string): WContactChooserResponseV0Dto[] {
    const keys = Object.keys(fields);
    const response: WContactChooserResponseV0Dto[] = [
      {
        uuid: null,
        id: null,
        label: placeholders,
        help: null,
        selected: true,
        filter: null
      }
    ];
    queryResponse.forEach((q: unknown) => {
      const obj = {};
      keys.forEach((outputKey: string) => {
        obj[outputKey] = q[fields[outputKey]];
      });
      response.push(obj as WContactChooserResponseV0Dto);
    });

    return response;
  }

  static generatePreview(col1: WContactChooserResponseV0Dto[],
                         col2: WContactChooserResponseV0Dto[],
                         col3: WContactChooserResponseV0Dto[],
                         value: WidgetContactChooserValueV0Dto[],
                         header: WidgetContactChooserValueV0Dto): WidgetHolderChooserPreviewDataV0 {
    const preview = {
      header,
      value: []
    } as WidgetHolderChooserPreviewDataV0;
    value?.forEach(row => {
      const actualValue = {
        col1: '',
        col2: '',
        col3: '',
        col4: '',
        useReferentEmail: false
      } as WidgetContactChooserValueV0Dto;

      if (row.col1) {
        const col1TableRow = col1?.find(c1 => c1.uuid === row.col1);
        if (col1TableRow) {
          actualValue.col1 = col1TableRow.label;
        }
      }

      if (row.col2) {
        const col2TableRow = col2?.find(c2 => c2.uuid === row.col2);
        if (col2TableRow) {
          actualValue.col2 = col2TableRow.label;
        }
      }

      if (row.col3) {
        const col3TableRow = col3?.find(c3 => c3.uuid === row.col3);
        if (col3TableRow) {
          actualValue.col3 = this.validString(col3TableRow.label) + ' ' + this.validString(col3TableRow.label2);
          if (row.useReferentEmail) {
            actualValue.col4 = col3TableRow.email;
          }
        }
      }

      if (!row.useReferentEmail) {
        actualValue.col4 = row.col4;
      }
      actualValue.useReferentEmail = row.useReferentEmail;
      preview.value.push(actualValue);
    });
    return preview;
  }

  static validString(value?: string): string {
    if (value !== undefined && value !== null && value !== 'undefined' && value !== null) {
      return value;
    }
    return '';
  }

  static getValidValue(value: WidgetContactChooserValueV0Dto[], data: WidgetContactChooserDataV0): WidgetContactChooserValueV0Dto[] {
    const validValue = [];
    if (value && value?.length > 0) {
      value.forEach((currentSavedValue: WidgetContactChooserValueV0Dto) => {
        let validCol1 = true;
        if (currentSavedValue.col1) {
          const col1ValidValue: WContactChooserResponseV0Dto = data?.col1?.find(c => c.uuid === currentSavedValue.col1);
          if (!col1ValidValue) {
            validCol1 = false;
          }
        }

        let validCol2 = true;
        if (currentSavedValue.col2) {
          const col2ValidValue: WContactChooserResponseV0Dto = data?.col2?.find(c => c.uuid === currentSavedValue.col2);
          if (!col2ValidValue || col2ValidValue.filter !== currentSavedValue.col1) {
            validCol2 = false;
          }
        }

        let validCol3 = true;
        if (currentSavedValue.col3) {
          const col3ValidValue: WContactChooserResponseV0Dto = data?.col3?.find(c => c.uuid === currentSavedValue.col3);
          if (!col3ValidValue || col3ValidValue.filter !== currentSavedValue.col2) {
            validCol3 = false;
          }
        }
        if (validCol1 && validCol2 && validCol3) {
          validValue.push(currentSavedValue);
        }
      });
    }
    return validValue;
  }
}








